module.exports = __webpack_public_path__ + "img/density_tile.e906fb24.jpg";